import {
  Button,
  Checkbox,
  Col,
  Flex,
  Form,
  Image,
  Input,
  Row,
  Typography,
} from "antd";
import styled from "styled-components";
import loginBg from "../../../assets/login-bg.png";

const { Title, Text, Link } = Typography;
const { Password } = Input;
const { Item } = Form;

export const PageRow = styled(Row)`
  && {
    width: 100%;
    min-height: 100vh;
    margin: 0;
    background: linear-gradient(134deg, #ffffff 1%, #ffffff 100%);
    font-family: "Roboto", sans-serif;
    flex-wrap: nowrap;
  }

  @media (min-width: 992px) {
    && {
      position: fixed;
      inset: 0;
      height: 100vh;
      overflow: hidden;
    }
  }
`;

export const LeftCol = styled(Col)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    padding: 38px 0 38px 34px;
    box-sizing: border-box;
    overflow: hidden;
  }

  @media (max-width: 991px) {
    && {
      display: none;
    }
  }
`;

export const ImageCard = styled(Flex)`
  &&,
  &&:empty {
    display: block;
    width: 100%;
    height: 100%;
    background-image: url(${loginBg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #d9d9d9;
    border-radius: 12px;
  }
`;

export const RightCol = styled(Col)`
  && {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    min-height: 100vh;
    padding: 32px 20px;
    box-sizing: border-box;
  }

  @media (min-width: 992px) {
    && {
      height: 100vh;
      min-height: 0;
      padding: 64px 16px 16px;
      overflow: hidden;
    }
  }
`;

export const FormCard = styled(Flex)`
  width: 100%;
  max-width: 414px;

  @media (min-width: 992px) {
    max-height: 100vh;
  }
`;

export const LogoImage = styled(Image)`
  margin-bottom: 40px;

  @media (max-width: 575px) {
    margin-bottom: 24px;
  }
`;

export const StyledTitle = styled(Title)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 36px !important;
    font-weight: 700 !important;
    line-height: 48px !important;
    color: #28323e !important;
    text-align: left;
    margin: 0 0 16px !important;
    width: 100%;
  }

  @media (max-width: 575px) {
    && {
      font-size: 28px !important;
      line-height: 36px !important;
    }
  }
`;

export const SubtitleRow = styled(Flex)`
  width: 100%;
  margin-bottom: 20px;
  align-items: center;
`;

export const SubtitleText = styled(Text)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 17px;
    color: #28323e;
  }
`;

export const SubtitleLink = styled(Link)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 700;
    line-height: 17px;
    color: #28323e;
    text-decoration: underline;

    &:hover {
      color: #28323e;
      text-decoration: underline;
    }
  }
`;

export const StyledForm = styled(Form)`
  width: 100%;

  .ant-form-item-label {
    padding-bottom: 6px;
  }

  .ant-form-item-label > label {
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 17px;
    color: #28323e;
    height: auto;
  }

  .ant-form-item {
    margin-bottom: 14px;
  }
`;

export const StyledInput = styled(Input)`
  && {
    height: 38px;
    border: 1px solid #d9d9d9;
    border-radius: 26px;
    padding: 0 19px;
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
    background: #ffffff;
    color: #28323e;

    &::placeholder {
      color: rgba(40, 50, 62, 0.6);
    }

    &:hover,
    &:focus {
      border-color: #4f78a1;
      box-shadow: none;
    }
  }
`;

export const StyledPasswordInput = styled(Password)`
  && {
    height: 38px;
    border: 1px solid #d9d9d9;
    border-radius: 26px;
    background: #ffffff;
    padding: 0 19px;

    &:hover,
    &:focus-within {
      border-color: #4f78a1;
      box-shadow: none;
    }

    .ant-input {
      border: none;
      background: transparent;
      padding: 0;
      font-family: "Roboto", sans-serif;
      font-size: 12px;
      font-weight: 400;
      line-height: 17px;
      color: #28323e;

      &::placeholder {
        color: rgba(40, 50, 62, 0.6);
      }

      &:focus {
        box-shadow: none;
      }
    }

    .ant-input-suffix {
      color: #28323e;
    }
  }
`;

export const ForgotRow = styled(Flex)`
  width: 100%;
  justify-content: flex-end;
  margin-top: -4px;
  margin-bottom: 12px;
`;

export const ForgotLink = styled(Link)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 17px;
    color: #28323e;
    text-decoration: underline;

    &:hover {
      color: #28323e;
      text-decoration: underline;
    }
  }
`;

export const TermsItem = styled(Item)`
  && {
    width: 100%;
    margin-top: 14px;
    margin-bottom: 0;
  }

  .ant-form-item-control-input {
    min-height: auto;
  }
`;

export const TermsText = styled(Text)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
    color: #28323e;
  }
`;

export const TermsLink = styled(Link)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 17px;
    color: #28323e;
    text-decoration: underline;

    &:hover {
      color: #28323e;
      text-decoration: underline;
    }
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  && {
    align-items: center;
    gap: 6px;

    .ant-checkbox-inner {
      width: 16px;
      height: 16px;
      border-radius: 3px;
      border: 2px solid #4f78a1;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #4f78a1;
      border-color: #4f78a1;
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: #ffffff;
      border-width: 2px;
    }

    & > span:not(.ant-checkbox) {
      display: inline-flex;
      align-items: baseline;
      gap: 4px;
      padding-inline-start: 8px;
    }
  }
`;

export const SubmitFormItem = styled(Item)`
  && {
    margin-bottom: 0;
    margin-top: 20px;
  }
`;

export const PrimaryButton = styled(Button)`
  && {
    width: 100%;
    height: 47px;
    border-radius: 26px;
    background: #28323e;
    border: none;
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #ffffff;

    &:hover {
      background: #1c2530 !important;
      color: #ffffff !important;
    }
  }
`;

export const OrDivider = styled(Text)`
  && {
    display: flex;
    align-items: center;
    width: 100%;
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
    color: #28323e;
    margin: 18px 0;
    text-align: center;
    justify-content: center;

    &::before,
    &::after {
      content: "";
      flex: 1;
      border-top: 1px solid rgba(40, 50, 62, 0.2);
    }

    &::before {
      margin-right: 13px;
    }

    &::after {
      margin-left: 13px;
    }
  }
`;

export const GoogleLoginWrapper = styled(Flex)`
  && {
    width: 100%;
  }

  & > div {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

